import idx from 'idx'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import { isEqual } from 'utils/misc'
import RowWithCheckbox from 'components/molecules/RowWithCheckbox'

import * as groupModule from 'modules/group'

export default compose(
  connect(
    (state) => {
      return {
        groups: idx(state, _ => _.groups.items),
        user: idx(state, _ => _.people.selected),
        loading: idx(state, _ => _.groups.loading),
        userGroups: idx(state, _ => _.groups.userItemsAll),
        organisation: idx(state, _ => _.organisation.selected)
      }
    }, 
    (dispatch) => {
      const actions = {
        ...groupModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      newGroupName: '',
      selectedGroups: [],
      bulkSelected: false,
      newGroupSelected: false,
      filters: {
        search: [{ key: 'name', value: null }],
        pagination: {
          offset: 0, limit: 10000
        },
        loaded: true,
      }
    }),
    {
      setAllGroups: ({ bulkSelected, newGroupName }) => selectedGroups => ({
        bulkSelected: !bulkSelected,
        newGroupSelected: newGroupName ? !bulkSelected : false,
        selectedGroups: bulkSelected ? [] : selectedGroups,
        newGroupName: bulkSelected ? '' : newGroupName
      }),
      setState: state => object => ({
        ...state,
        ...object
      }),
      onClearClick: () => () => ({
        newGroupName: '',
        selectedGroups: [],
        bulkSelected: false,
        newGroupSelected: false,
      }),
      onGroupTextChange: () => event => ({
        newGroupName: event.target.value,
        newGroupSelected: event.target.value.length > 0
      }),
      onNewGroupSelect: state => () => ({
        newGroupSelected: !state.newGroupSelected,
        newGroupName: state.newGroupSelected ? '' : state.newGroupName,
      }),
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({ search: [{ key: 'name', value }] })
    },
    onGroupSelect: ({ setState, ...state }) => (groupUuid) => {
      const selectedGroups = [...state.selectedGroups]
      const groupIndex = selectedGroups.indexOf(groupUuid)

      if (groupIndex > -1) {
        selectedGroups.splice(groupIndex, 1)
      } else {
        selectedGroups.push(groupUuid)
      }
      setState({
        selectedGroups,
        bulkSelected: false,
      })
    },
    onBulkSelect: ({ setAllGroups, groups, userGroups }) => () => {
      setAllGroups(Object.keys(groups).filter(group => !(userGroups && group in userGroups)))
    },
    onConfirmClick: ({
      data, 
      actions, 
      newGroupName, 
      organisation, 
      selectedGroups, 
      newGroupSelected 
    }) => () => {
      if (newGroupName && newGroupSelected) {
        actions.createGroup({name: newGroupName}, organisation, (group) => {
          const newSelectedGroups = selectedGroups.concat(group.uuid)
          data.onConfirm(newSelectedGroups)
        })
      }
      data.onConfirm(selectedGroups)
    }
  }),
  withHandlers({
    renderGroupsList: ({
      groups,
      userGroups,
      onGroupSelect,
      selectedGroups,
    }) => () => {
      if (!Object.keys(groups).length) {
        return null
      }

      return Object.keys(groups)
        .filter((group) => {
          const isUserGroup = userGroups && Object.keys(userGroups).some(item => group === item)
          return !isUserGroup
        })
        .map((item) => {
          const isSelected = selectedGroups.indexOf(item) > -1
          const group = groups[item]

          return (
            <RowWithCheckbox 
              key={group.uuid || group.groupUuid}
              data={group.uuid}
              title={group.name}
              selected={isSelected}
              onSelect={onGroupSelect}
            />
          )
        })
    },
  }),
  lifecycle({
    componentDidMount() {
      const { 
        actions, user, organisation, filters, data
      } = this.props

      actions.getGroups(organisation, filters)
      if (data.filterAssignedGroups && user) {
        actions.getAllUserGroups(user, organisation)
      }
    },
    componentDidUpdate(prevProps) {
      const {
        actions, user, organisation, filters, data
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getGroups(organisation, filters)
        if (data.filterAssignedGroups && user) {
          actions.getAllUserGroups(user, organisation)
        }
      }
    }
  }),
)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignGroupsPopover/AssignGroupsPopover.enhancer.js